import { JsonObject, JsonProperty } from 'json2typescript';

@JsonObject('UserMatchPlayer')
export class UserMatchPlayer {

  @JsonProperty('user_id', Number)
  userId: number = 0;

  @JsonProperty('user_displayname', String)
  userDisplayname: string = '';

  @JsonProperty('rank', Number)
  rank: number = 0;

  @JsonProperty('score', Number)
  score: number = 0;

  @JsonProperty('is_exited', Boolean)
  isExited: boolean = false;

  @JsonProperty('matchmaker_ticket_id', String)
  matchmakerTicketId: string = '';

  @JsonProperty('matchmaker_player_session_id', String)
  matchmakerPlayerSessionId: string = '';
}
